import { AxiosResponse } from 'axios';
import { API } from 'config';
import { LIST_BODY_RESULT } from 'models';
import {
  BODY_CREATE_PACKAGE,
  BODY_UPDATE_PACKAGE,
  PACKAGE_LIST_PARAMS_REQUEST,
  PACKAGE_TYPE,
} from 'models/package';
import { AppAPIInstance } from 'services/config-api';

export const getPackageListApi = async (
  params?: PACKAGE_LIST_PARAMS_REQUEST
): Promise<AxiosResponse<{ data: LIST_BODY_RESULT<PACKAGE_TYPE> }>> => {
  return await AppAPIInstance.get(API.PACKAGE.DEFAULT, { params });
};

export const createPackageApi = async (data: BODY_CREATE_PACKAGE) => {
  return await AppAPIInstance.post(API.PACKAGE.DEFAULT, data);
};

export const editPackageApi = async (id: string, data: BODY_UPDATE_PACKAGE) => {
  return await AppAPIInstance.put(`${API.PACKAGE.DEFAULT}/${id}`, data);
};

export const deletePackageApi = async (id: string) => {
  return await AppAPIInstance.delete(`${API.PACKAGE.DEFAULT}/${id}`);
};
